import { render, staticRenderFns } from "./LogoSlider.vue?vue&type=template&id=6efbb080&"
import script from "./LogoSlider.vue?vue&type=script&lang=coffee&"
export * from "./LogoSlider.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports